import { createFileRoute } from "@tanstack/react-router";
import StaffAdminGate from "@/components/StaffAdminGate";
import AdminFunnelReport from "@/pages/AdminFunnelReport";

export const Route = createFileRoute("/admin/funnel")({
  component: () => (
    <StaffAdminGate>
      <AdminFunnelReport />
    </StaffAdminGate>
  ),
});
